import React, { ChangeEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { Main, DivInputContainer, Input, TagError } from '../../styles';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 50vw;
`;

interface IContactConfirmation {
  info: string;
  type: string;
  contact: string;
  setContact: React.Dispatch<React.SetStateAction<string>>;
}
const ContactConfirmation: React.FC<IContactConfirmation> = ({
  info,
  type,
  contact,
  setContact,
}) => {
  const { msg } = useSelector((state: ApplicationState) => ({
    msg: state.auth.status,
  }));
  const [errorContact, setErrorContact] = useState<boolean>(false);

  useEffect(() => {
    setErrorContact(
      msg === 'Email diferente do cadastrado' ||
        msg === 'Telefone diferente do cadastrado'
    );
  }, [msg]);
  return (
    <Wrapper>
      <Main>
        <>
          <h1>Autenticação</h1>
          <p>Insira o contato selecionado para continuar</p>
          <p>{info}</p>
        </>
      </Main>
      <DivInputContainer error={errorContact}>
        <Input
          value={contact}
          type={`${type}`}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setContact(e.target.value);
          }}
        />
        {errorContact && <TagError>Contato inserido incorretamente</TagError>}
      </DivInputContainer>
    </Wrapper>
  );
};

export default ContactConfirmation;
